import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';

import { ActionsColumn, IdColumn } from './columns';
import {
    Box,
    Container,
    Flex,
    Group,
    MultiSelect,
    Portal,
    Select,
    Text,
} from '@mantine/core';
import { MultiSelectCreatable, StatColumn, TextColumn } from '../../../common';
import {
    getChatScripts,
    getDatasets,
    getMessageGroups,
} from '../../../../http/apiClient';
import { useDebouncedCallback, useLocalStorage } from '@mantine/hooks';
import { useMemo, useState } from 'react';

import ChatScriptTableToolbar from './toolbars/ChatScriptTableToolbar';
import { MantineReactTable } from 'mantine-react-table';
import { naiveRound } from '../../../../utils/text';
import { sumObjectKeys } from '../../../../utils/statUtils';
import { usePaginatedQuery } from '../../../../http/queries/usePaginatedQuery';

const ChatScriptListView = ({ ...props }) => {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 50,
    });

    const filterDebounce = useDebouncedCallback((query) => {
        setGlobalFilter(query);
    }, 600);

    const {
        isLoading,
        isError,
        error,
        data: paginatedData,
    } = usePaginatedQuery({
        queryFn: (queryParams) => getChatScripts(queryParams),
        queryKey: ['chat_scripts'],
        refetchInterval: 15_0000,
        globalFilter,
        pagination,
        sorting,
    });

    const { data: scripts, pagination: dataPagination } = paginatedData || {};
    const columns = useMemo(
        () => [
            IdColumn(),
            TextColumn({ accessorKey: 'name', header: 'Name' }),

            StatColumn('Sent', (x) => x.stats?.send),
            StatColumn('Clicks', (x) =>
                sumObjectKeys(x.stats, ['uniqueClick', 'uniquePreview'])
            ),
            StatColumn(
                'CTR',
                (x) => {
                    const uniqueClicks = sumObjectKeys(x.stats, [
                        'uniqueClick',
                        'uniquePreview',
                    ]);
                    return naiveRound((uniqueClicks / x.stats?.send) * 100, 2);
                },
                true
            ),
            StatColumn('Conversions', (x) => x.stats?.conversion),
            StatColumn(
                'CR',
                (x) => {
                    /*const uniqueClicks = sumObjectKeys(x.stats, [
                        'uniqueClick',
                        'uniquePreview',
                    ]);*/
                    const uniqueClicks = x.stats?.send;
                    return naiveRound(
                        (x.stats?.conversion / uniqueClicks) * 100,
                        2
                    );
                },
                true
            ),
        ],
        [scripts]
    );

    /*const tableData = useMemo(
        () => (isLoading ? [] : campaigns),
        [campaigns, isLoading]
    );*/

    const tableData = useMemo(
        () => (isLoading ? [] : scripts),
        [scripts, isLoading]
    );

    const [columnVisibility, setColumnVisibility] = useLocalStorage({
        key: 'scripts-table-visibility', // a unique key for local storage
        defaultValue: {}, // default to all columns shown if empty
        getInitialValueInEffect: true,
    });

    const [columnSizing, setColumnSizing] = useLocalStorage({
        key: 'scripts-group-table-sizing', // a unique key for local storage
        defaultValue: {}, // default to all columns shown if empty
        getInitialValueInEffect: true,
    });

    const handleVisibilityChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnVisibility((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handlSizeChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnSizing((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handleFilterChange = (queryStr) => {
        filterDebounce(queryStr);
    };

    const tableProps = {
        columns: columns,
        data: tableData,
        enableRowActions: true,
        enableColumnResizing: true,
        enableColumnActions: false,
        enableSorting: false,
        enableTopToolbar: true,
        enableGlobalFilter: true,
        enableFilters: false,
        enableStickyHeader: true,
        enableDensityToggle: false,
        positionActionsColumn: 'last',
        layoutMode: 'semantic',
        mantineSearchTextInputProps: {
            placeholder: 'Search Datasets',
            miw: 200,
        },
        mantineTableContainerProps: {
            style: {
                minHeight: '80vh',
            },
        },
        positionGlobalFilter: 'left',
        renderTopToolbarCustomActions: ({ props: table }) => (
            <ChatScriptTableToolbar
                table={table}
                filterOptions={[]}
            />
        ),
        renderRowActions: ActionsColumn,

        manualPagination: true,
        manualSorting: true,
        onColumnVisibilityChange: handleVisibilityChange,
        onColumnSizingChange: handlSizeChange,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        onGlobalFilterChange: handleFilterChange,
        rowCount: dataPagination?.totalItems || 0,
        pageCount: dataPagination?.totalPages || 1,

        initialState: {
            columnVisibility,
            pagination,
            isLoading,
            showGlobalFilter: true,
        },
        state: {
            isLoading,
            pagination,
            columnVisibility,
            columnSizing,
            showAlertBanner: isError,
            showProgressBars: isLoading,
            sorting,
            density: 'xs',
        },
    };

    return (
        <Container fluid>
            <MantineReactTable {...tableProps} />
        </Container>
    );
};
export default ChatScriptListView;
